import axios from '../service/axios/axios'

export default {
  // 获取员工列表
  getStaffList(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/getStaffList',
      data: data,
    })
  },
  // 设置员工状态
  setStaffStatus(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/setStaffStatus',
      data: data,
    })
  },
  // 保存员工信息
  saveStaffInfo(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/saveStaffInfo',
      data: data,
    })
  },
  // 获取指标信息列表
  getStaffTargetList(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/getStaffTargetList',
      data: data,
    })
  },
  // 保存指标信息
  saveTargetInfo(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/saveTargetInfo',
      data: data,
    })
  },
  // 删除指标信息
  deleteTargetInfo(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/deleteTargetInfo',
      data: data,
    })
  },
  // 导入指标
  importTarget(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/importTarget',
      data: data,
    })
  },
  // 获取员工提成设置列表
  getStaffProportionList(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/getStaffProportionList',
      data: data,
    })
  },
  // 设置员工提成
  setStaffProportionInfo(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/setStaffProportionInfo',
      data: data,
    })
  },
  // 按月按员工提成管理列表
  getProportionManageList(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/getProportionManageList',
      data: data,
    })
  },
  // 按月提成管理列表
  getDateProportionManageList(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/getDateProportionManageList',
      data: data,
    })
  },
  // 按员工提成管理列表
  getStaffProportionManageList(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/getStaffProportionManageList',
      data: data,
    })
  },
  // 获取相关订单信息
  getRelatedOrderList(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/getRelatedOrderList',
      data: data,
    })
  },
  // 设置可提成金额
  setPercentageMoney(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/setPercentageMoney',
      data: data,
    })
  },
  // 设置员工可提现状态
  setStaffApplyStatus(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/setStaffApplyStatus',
      data: data,
    })
  },
  // 通过员工提现申请
  passStaffApplyInfo(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/passStaffApplyInfo',
      data: data,
    })
  },
  // 设置员工提现申请异常状态
  setStaffApplyAbnormal(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/setStaffApplyAbnormal',
      data: data,
    })
  },
  // 导出提成管理列表 按月按员工
  exportProportionList(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/exportProportionList',
      data: data,
    })
  },
  // 导出按员工提成管理列表
  exportStaffProportionManageList(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/exportStaffProportionManageList',
      data: data,
    })
  },
  // 导出按月提成管理列表
  exportDateProportionManageList(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/exportDateProportionManageList',
      data: data,
    })
  },
  //  员工基础列表
  getStaffBaseList(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/getStaffBaseList',
      data: data,
    })
  },
  /** 员工奖励---start  */
  // 医生活跃开单奖励 
  recommenderActiveDoctorReward(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/recommenderActiveDoctorReward',
      data: data,
    })
  },
  // 医生活跃开单奖励 导出
  recommenderActiveDoctorRewardExport(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/recommenderActiveDoctorRewardExport',
      data: data,
    })
  },
  // 开单新医生奖励
  newDoctorReward(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/newDoctorReward',
      data: data,
    })
  },
  // 开单新医生奖励 导出
  newDoctorRewardExport(data) {
    return axios({
      method: 'post',
      url: 'platform/staff/newDoctorRewardExport',
      data: data,
    })
  },
  // 业务所属领导奖励
  recommenderleaderreward(data) {
    return axios({
      method: 'post',
      url: 'platform/Staff/recommenderleaderreward',
      data: data,
    })
  },
  // 业务所属领导奖励 导出
  recommenderleaderrewardexport(data) {
    return axios({
      method: 'post',
      url: 'platform//Staff/recommenderleaderrewardexport',
      data: data,
    })
  },
  // // 员工奖励详情
  // recommenderEncourageItem(data) {
  //   return axios({
  //     method: 'post',
  //     url: 'platform/staff/recommenderEncourageItem',
  //     data: data,
  //   })
  // },
  // // 员工奖励详情-月份
  // recommenderEncourageItemMonth(data) {
  //   return axios({
  //     method: 'post',
  //     url: 'platform/staff/recommenderEncourageItemMonth',
  //     data: data,
  //   })
  // },
  // // 员工奖励详情导出
  // recommenderEncourageItemExport(data) {
  //   return axios({
  //     method: 'post',
  //     url: 'platform/staff/recommenderEncourageItemExport',
  //     data: data,
  //   })
  // },
  // // 员工奖励明细
  // recommenderEncourageItemList(data) {
  //   return axios({
  //     method: 'post',
  //     url: 'platform/staff/recommenderEncourageItemList',
  //     data: data,
  //   })
  // },
  /** 员工奖励---end  */
}
